import styled from 'styled-components'

export const ReportsContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: ${({ theme }) => theme['gray-300']};
    display: flex;
    flex-direction: row;
    padding: 16px;
    &,
    * {
        transition: 0.3s all;
    }
`
